// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const FolderEmpty = (): React.Element<*> => (
  <path d="M10.005 14.984c-0 0-0 0-0.001 0-0.138 0-0.263-0.056-0.353-0.146v0l-4.495-4.494c-0.091-0.090-0.146-0.216-0.146-0.354s0.056-0.263 0.146-0.354l4.495-4.495c0.090-0.091 0.216-0.146 0.354-0.146s0.263 0.056 0.354 0.146l4.495 4.495c0.091 0.090 0.146 0.216 0.146 0.354s-0.056 0.263-0.146 0.354l-4.494 4.495c-0.090 0.090-0.215 0.146-0.352 0.146-0.001 0-0.002 0-0.002 0h0zM6.217 9.99l3.788 3.788 3.788-3.788-3.788-3.788z"></path>
);
